// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".notification-table-component .title .detail-link[data-v-87dff4c4]{margin-right:8px;word-break:break-all}.notification-table-component .title .new[data-v-87dff4c4]{min-width:36px;color:#d94a7d;font-size:12px;border:1px solid #d94a7d;padding:0 4px 0 4px;margin:3px 6px 4px 0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
